import { useContext, useCallback } from 'react';
import { 
  Button,
  styled
} from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { Add, ControlPoint as ControlPointIcon } from '@mui/icons-material';
import { AuthContext } from 'components';
import { AddPhotoIcon } from 'components/Icons';
import { getStorage, ref as storage_ref, uploadBytes } from "firebase/storage";


const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const custom_css = `
  .carousel .thumbs {
    padding-left: 0;
    text-align: center;
    overflow-y: scroll;
  }
`


export const PhotoUpload = (props) => {
  const { product, onChange, upload_input_props, open_upload_file_selector } = props
  const { accountId } = useContext(AuthContext)
  let photos = product.photos || []

  return (
    <Button key="photo-upload" component="label" size="small" onClick={open_upload_file_selector} startIcon={ <AddPhotoIcon style={{ width: 40, height: 40 }}/> }>
      <style>{custom_css}</style>
      Drag & drop or click to select files

      <VisuallyHiddenInput {...upload_input_props()} multiple onChange={(e) => {
        const storage = getStorage();
        const upload_buffer = []
        for (const f of e.target.files) {
          let name = uuidv4();
          const storageRef = storage_ref(storage, `${accountId}/${name}.jpg`);
          let metadata = { name }
  
          upload_buffer.push(new Promise((resolve, reject) => {
            uploadBytes(storageRef, f, metadata).then((snapshot) => {
              resolve(name)
            })
          }))
        }
  
        Promise.all(upload_buffer).then((values) => {
          let current_photos = product.photos || []

          onChange([...current_photos, ...values].filter(p => p !== 'missing_image'))
        })
      }} type="file" />
    </Button>
  )
}